import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Action = styled.div`
  margin-top: 20px;
`;
